 <div class="container" [hidden]="loading">
   <mat-card class="grey-font">
     <mat-card-title class="flex-important space-between">
       User/Vendor Report
      <button mat-raised-button color="primary" class="main-button" (click)="downloadReport()">Get Report</button>
     </mat-card-title>
   </mat-card>
 </div>
 <app-loading [hidden]="!loading"></app-loading>
